<template>
  <div
    class="fit flex flex-center duration-700 absolute left-0 top-0"
    :style="{
      transform: `scale(${views[value.toLowerCase()].scale}) translate(${views[value.toLowerCase()].x}%, ${views[value.toLowerCase()].y}%)`,
    }"
  >
    <div class="flex h-full bg- relative" style="width: fit-content">
      <img
        src="/maintenance/truck.png"
        class="h-full object-contain"
        draggable="false"
      />
      <div class="fit absolute left-0 top-0 bg- pointer-events-none">
        <div
          class="hover-scale duration-200 absolute bg- flex justify-center"
          style="height: 5.5%; width: 10%; pointer-events: auto"
          :style="[{ left: `${tire.x + 6}%`, top: `${tire.y}%` }]"
          v-for="(tire, key) in tyres"
          :key="key"
        >
          <img
            v-for="n in singleTyre[key.charAt(0).toLowerCase()] ? 1 : 2"
            :key="`main-tire${n}`"
            @click="$emit('input', key)"
            v-if="visible.includes(key.toUpperCase())"
            src="/maintenance/tyre.png"
            alt=""
            class="object-cover cursor-pointer duration-200 z-10"
            style="height: 120%; width: 70%"
            :style="
              n == 2
                ? key.charAt(1).toLowerCase() == 'l'
                  ? {
                      transform: 'translateX(-14px)',
                    }
                  : {
                      transform: 'translateX(14px)',
                    }
                : { position: 'absolute' }
            "
            draggable="false"
          />
          <img
            v-for="n in singleTyre[key.charAt(0).toLowerCase()] ? 1 : 2"
            :key="`highlight${n}`"
            v-if="
              visible.includes(key.toUpperCase()) && key == value.toLowerCase()
            "
            src="/maintenance/tyre.png"
            alt=""
            class="absolute object-contain cursor-pointer duration-200 z-0 h-full pointer-events-none"
            style="
              height: 150%;
              pointer-events: auto;
              filter: invert(0%) sepia(50%) saturate(15000%) hue-rotate(200deg);
              transform: translateY(4px) scale(1.5, 1.4);
            "
            :style="
              n == 2
                ? key.charAt(1).toLowerCase() == 'l'
                  ? {
                      transform: 'translate(-14px,4px) scale(1.5, 1.4)',
                    }
                  : {
                      transform: 'translate(14px,4px) scale(1.5, 1.4)',
                    }
                : { position: '' }
            "
            draggable="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  value: { default: 'general' },
  ui: { default: false },
  tyre: Object,
});

const singleTyre = computed(() => {
  if (props.tyre) {
    return Object.fromEntries(
      Object.keys(props.tyre).map((key) => {
        let initial = key.charAt(0).toLowerCase();
        return [initial, props.tyre[key].single];
      }),
    );
  }
});

const visible = computed(() => {
  let arr = [];
  if (props.ui) {
    for (const key in props.ui) {
      let obj = props.ui[key];
      arr.push(...obj);
    }
  }
  return arr;
});

const views = {
  general: { scale: 0.9, x: 0, y: 0 },
  fr1: { scale: 2, x: -20, y: 30 },
  fl1: { scale: 2, x: 20, y: 30 },
  mr1: { scale: 2, x: -20, y: 15 },
  ml1: { scale: 2, x: 20, y: 15 },
  mr2: { scale: 2, x: -20, y: 5 },
  ml2: { scale: 2, x: 20, y: 5 },
  mr3: { scale: 2, x: -20, y: -5 },
  ml3: { scale: 2, x: 20, y: -5 },
  mr4: { scale: 2, x: -20, y: -15 },
  ml4: { scale: 2, x: 20, y: -15 },
  br1: { scale: 2, x: -20, y: -30 },
  bl1: { scale: 2, x: 20, y: -30 },
  br2: { scale: 2, x: -20, y: -40 },
  bl2: { scale: 2, x: 20, y: -40 },
  br3: { scale: 2, x: -20, y: -50 },
  bl3: { scale: 2, x: 20, y: -50 },
};
const tyres = {
  fl1: {
    x: -1,
    y: 7,
  },
  fr1: {
    x: 77,
    y: 7,
  },
  ml1: {
    x: -1,
    y: 22,
  },
  mr1: {
    x: 77,
    y: 22,
  },
  ml2: {
    x: -1,
    y: 29,
  },
  mr2: {
    x: 77,
    y: 29,
  },
  ml3: {
    x: -1,
    y: 36,
  },
  mr3: {
    x: 77,
    y: 36,
  },
  ml4: {
    x: -1,
    y: 43,
  },
  mr4: {
    x: 77,
    y: 43,
  },
  bl1: {
    x: -1,
    y: 74,
  },
  bl2: {
    x: -1,
    y: 81,
  },
  bl3: {
    x: -1,
    y: 88,
  },
  br1: {
    x: 77,
    y: 74,
  },
  br2: {
    x: 77,
    y: 81,
  },
  br3: {
    x: 77,
    y: 88,
  },
};
</script>

<style lang="scss">
.hover-scale:hover {
  transform: scale(1.1);
}
</style>
